import { useEffect, useState } from "react";
import axios from "axios";

import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Swal from "sweetalert2";

import Header from "../components/Header/Header";
import Instruction from "../components/instructions/Instruction";
import Documents from "../components/documents";
import AFFIDAVIT from "../files/Affidavit Sample.pdf";
export default function Form() {
  const [universites, setUniversities] = useState([]);
  const [years, setYears] = useState([]);
  const [district, setDistrict] = useState([]);
  const [discipline, setDiscipline] = useState([]);

  const [previewMode, setPreviewMode] = useState(false);
  const [propertyType, setPropertyType] = useState("");
  const [nonResidenceProperty, setNonResidenceProperty] = useState("");

  const [isSiblingAvailingScholarship, setIsSiblingAvailingScholarship] =
    useState(null);
  // const [siblingDetails, setSiblingDetails] = useState(null);

  const handleCheckboxChange = (event, from) => {
    const isChecked = event.target.checked;

    // console.log("from:", from);

    if (from === "yes") {
      setIsSiblingAvailingScholarship(isChecked);

      if (isChecked) {
        // Display the Swal dialog for sibling details
        Swal.fire({
          title: "Sibling Details",
          html:
            '<input id="swal-input1" class="swal2-input" placeholder="Name">' +
            '<input id="swal-input2" class="swal2-input" placeholder="Relationship">' +
            '<input id="swal-input3" class="swal2-input" placeholder="University">',
          showCancelButton: true,
          confirmButtonText: "Submit",
          preConfirm: () => {
            const name = Swal.getPopup().querySelector("#swal-input1").value;
            const relationship =
              Swal.getPopup().querySelector("#swal-input2").value;
            const university =
              Swal.getPopup().querySelector("#swal-input3").value;

            // Set the sibling details
            const sibling = {
              name,
              relationship,
              university,
            };
            // setSiblingDetails(sibling);

            setFormData({ ...formData, siblingDetails: sibling });
          },
        }).then((result) => {
          if (result.isConfirmed) {
          } else {
            setIsSiblingAvailingScholarship(null); // Uncheck the checkboxes
          }
        });
      } else {
        // setSiblingDetails(null); // Reset the sibling details when checkbox is unchecked
      }
    } else {
      // console.log("ekse");
      setIsSiblingAvailingScholarship(false);
      setFormData({ ...formData, siblingDetails: null });
    }
  };

  const [formData, setFormData] = useState({
    family: [],

    property: [
      {
        propertyResidence: "",
        addressResidence: "",
        areaResidence: "",
        valueResidence: "",
      },
      {
        propertyNonResidence: "",
        addressNonResidence: "",
        areaNonResidence: "",
        valueNonResidence: "",
      },
    ],
    income: [
      {
        fProfession: "",
        fIncome: "",
        fTotalIncome: "",
      },
      {
        mProfession: "",
        mIncome: "",
        mTotalIncome: "",
      },
      {
        bProfession: "",
        bIncome: "",
        bTotalIncome: "",
      },
      {
        sProfession: "",
        sIncome: "",
        sTotalIncome: "",
      },
      {
        gProfession: "",
        gIncome: "",
        gTotalIncome: "",
      },
    ],
  });

  console.log("formData");
  console.log(formData);

  // 1. Academic "Grade System"

  const GradeSystem = {
    CGPA: "CGPA",
    PERCENTAGE: "Percentage",
    FIRSTYEAR: "First Year",
  };

  const [selectedGradeSystem, setSelectedGradeSystem] = useState(null);
  const [gradeInput, setGradeInput] = useState("");

  const handleGradeSystemChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedGradeSystem(selectedValue);

    if (selectedValue === GradeSystem.FIRSTYEAR) {
      setFormData({
        ...formData,
        percentage_id: "First Year Student",
      });
    } else {
      setFormData({
        ...formData,
        percentage_id: "",
      });
    }
  };

  const handleGradeInputChange = (event) => {
    // setResult(event.target.value);
  };

  // 3. Financial "Property Starts"

  const handlePropertyResidenceOnChange = (e) => {
    setPropertyType(e.target.value);

    setFormData((prevState) => ({
      ...prevState,
      property: [
        {
          ...prevState.property[0],
          propertyResidence: e.target.value,
        },
        prevState.property[1],
      ],
    }));
  };
  const handleAddressResidenceOnchange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      property: [
        {
          ...prevState.property[0],
          addressResidence: e.target.value,
        },
        prevState.property[1],
      ],
    }));
  };

  const handleAreaResidenceOnchange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      property: [
        {
          ...prevState.property[0],
          areaResidence: e.target.value,
        },
        prevState.property[1],
      ],
    }));
  };

  const handleValueResidenceOnchange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      property: [
        {
          ...prevState.property[0],
          valueResidence: e.target.value,
        },
        prevState.property[1],
      ],
    }));
  };

  const handlePropertyNonResidenceOnChange = (e) => {
    setNonResidenceProperty(e.target.value);

    setFormData((prevState) => ({
      ...prevState, // keep the previous state as is
      property: [
        prevState.property[0], // keep the first object as is
        {
          ...prevState.property[1], // keep the second object as is
          propertyNonResidence: e.target.value, // update the propertyResidence value
        },
      ],
    }));
  };

  const handleNonResidenceAddress = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      property: [
        prevState.property[0],
        {
          ...prevState.property[1],
          addressNonResidence: e.target.value,
        },
      ],
    }));
  };
  const handleNonResidenceArea = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      property: [
        prevState.property[0],
        {
          ...prevState.property[1],
          areaNonResidence: e.target.value,
        },
      ],
    }));
  };

  const handleNonResidenceValue = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      property: [
        prevState.property[0],
        {
          ...prevState.property[1],
          valueNonResidence: e.target.value,
        },
      ],
    }));
  };

  const [allIncome, setAllIncome] = useState(0);

  const grandTotalIncome = formData.income.reduce(
    (total, incomeData) =>
      total +
      parseFloat(incomeData.fTotalIncome || 0) +
      parseFloat(incomeData.mTotalIncome || 0) +
      parseFloat(incomeData.bTotalIncome || 0) +
      parseFloat(incomeData.sTotalIncome || 0) +
      parseFloat(incomeData.gTotalIncome || 0),
    0
  );

  // Preview
  const handleSubmit = (e) => {
    e.preventDefault();
    setPreviewMode(true);
    setFormData({ ...formData, totalIncomePerAnnum: allIncome });
  };
  //  new done by me family
  const [students, setStudents] = useState([]);
  const [nameInputValue, setNameInputValue] = useState("");
  const [ageInputValue, setAgeInputValue] = useState("");
  const [relationshipInputValue, setRelationshipInputValue] = useState("");
  const [statusInputValue, setStatusInputValue] = useState("");
  const [occupationInputValue, setOccupationInputValue] = useState("");
  const [organisationInputValue, setOrganisationInputValue] = useState("");

  const handleNameInputChange = (event) => {
    setNameInputValue(event.target.value);
  };

  const handleAgeInputChange = (event) => {
    setAgeInputValue(event.target.value);
  };

  const handleRelationshipInputChange = (event) => {
    setRelationshipInputValue(event.target.value);
  };

  const handleStatusInputChange = (event) => {
    setStatusInputValue(event.target.value);
  };

  const handleOccupationInputChange = (event) => {
    setOccupationInputValue(event.target.value);
  };

  const handleOrganisationInputChange = (event) => {
    setOrganisationInputValue(event.target.value);
  };
  const handleAddStudent = () => {
    if (
      nameInputValue.trim() !== "" &&
      ageInputValue.trim() !== "" &&
      relationshipInputValue.trim() !== "" &&
      statusInputValue.trim() !== "" &&
      occupationInputValue.trim() !== "" &&
      organisationInputValue.trim() !== ""
    ) {
      const newStudent = {
        id: Date.now(),
        name: nameInputValue,
        age: Number(ageInputValue),
        relationship: relationshipInputValue,
        status: statusInputValue,
        occupation: occupationInputValue,
        organisation: organisationInputValue,
      };
      setStudents([...students, newStudent]);

      let { family } = formData;

      family.push({
        memberName: nameInputValue,
        memberAge: ageInputValue,
        mebmerRelation: relationshipInputValue,
        memberMaritalStatus: statusInputValue,
        memberOccupation: occupationInputValue,
        memberOrganisation: organisationInputValue,
      });

      setFormData({ ...formData, family: family });

      setNameInputValue("");
      setAgeInputValue("");
      setRelationshipInputValue("");
      setStatusInputValue("");
      setOccupationInputValue("");
      setOrganisationInputValue("");
    }
  };

  const handleDeleteStudent = (id) => {
    const updatedStudents = students.filter((student) => student.id !== id);
    setStudents(updatedStudents);
  };

  const handleEdit = () => {
    setPreviewMode(false);
  };

  const handleDownload = () => {
    setLoading(true);
    // Create a new PDF document
    // const doc = new jsPDF();
    const doc = new jsPDF("a4");

    const tableData = [
      [
        "Apply as",
        ":",
        formData?.candidate,
        "University Reg. No #",
        ":",
        formData?.roll_number,
      ],
      [
        "Year of Admission",
        ":",
        formData?.year_id,
        "University / Institute",
        ":",
        formData?.university_id,
      ],
      [
        "CGPA / Percentage",
        ":",
        formData?.percentage_id,
        "Discipline",
        ":",
        formData?.discipline_id,
      ],
    ];

    const tableData2 = [
      [
        "First Name",
        ":",
        formData?.first_name,
        "Last Name",
        ":",
        formData?.last_name,
      ],
      [
        "Father / Guardian Name",
        ":",
        formData?.parentName,
        "CNIC No. of Student",
        ":",
        formData?.cnic,
      ],
      [
        "Phone Number",
        ":",
        formData?.mobile,
        "Phone Residence",
        ":",
        formData?.landline,
      ],
      ["Email", ":", formData?.email, "Domicile", ":", formData?.domicile_id],
    ];

    // Instruction

    const tableData3 = [
      [
        "1. Copy of Student Identity Card of the University / Institute.",
        "2. Copy of Student CNIC/Copy of CNIC of Father / Guardian.",
      ],
      [
        "3. Copy of Fee Receipt of the University / Institute (Last Paid).",
        " 4. Copy of Certificate of Domicile of the student.",
      ],
      [
        "5. Copy of Permanent Residence Certificate of Student.",
        "6. Copy of Domicile Certificate of Father / Mother / Guardian.",
      ],
      [
        "7. Copy of Academic Certificates including MarkSheets of previous year.",
        "8. Copy of House documents being the evidence of Residence/Rent document.",
      ],
      [
        "9. Original Salary Slip of Father / Guardian if employed in Government / Semi Government / Private organization.",
        "10. Original Income Certificate issued by Mukhtarkar Revenue of concerned District in case Father / Guardian is a non-salary person i.e. Business man / Landlord etc., along with Bank Statement of last six (6) months of personal and Business account.",
      ],
      [
        "11. Original Copy of Income Assessment / Return of Income duly issued by Income Tax Department, Government of Pakistan.",
        "12. Copies of Utility Bills: Electricity / Gas / Telephone (Last paid).",
      ],
      [
        "13. Original Affidavit on Rs. 50/= Stamp paper.",
        "14. Incomplete applications will not be considered.",
      ],
    ];

    const headers = [
      "Name",
      "Age",
      "Relationship",
      "Status",
      "Occupation",
      "Organisation",
    ];
    const data = students.map((student) => [
      student.name,
      `${student.age} Years`,
      student.relationship,
      student.status,
      student.occupation,
      student.organisation,
    ]);

    const propertyHeaders = [
      "Property Type",
      "Exact Location",
      "Area ( in Acres\n/ Sq Yards)",
      "Value",
    ];
    const propertyData = [
      [
        formData.property[0].propertyResidence,
        formData.property[0].addressResidence,
        formData.property[0].areaResidence,
        formData.property[0].valueResidence,
      ],
      [
        formData.property[1].propertyNonResidence,
        formData.property[1].addressNonResidence,
        formData.property[1].areaNonResidence,
        formData.property[1].valueNonResidence,
      ],
    ];

    const incomeHeaders = [
      "",
      "Father's",
      "Mother's",
      "Brother's",
      "Sister's",
      "Guardian's /\nOther's",
    ];
    const incomeData = [
      [
        "Profession",
        formData.income[0].fProfession,
        formData.income[1].mProfession,
        formData.income[2].bProfession,
        formData.income[3].sProfession,
        formData.income[4].gProfession,
      ],
      [
        "Salary / Pension",
        formData.income[0].fIncome,
        formData.income[1].mIncome,
        formData.income[2].bIncome,
        formData.income[3].sIncome,
        formData.income[4].gIncome,
      ],
      [
        "Income from all Sources",
        formData.income[0].fTotalIncome,
        formData.income[1].mTotalIncome,
        formData.income[2].bTotalIncome,
        formData.income[3].sTotalIncome,
        formData.income[4].gTotalIncome,
      ],
    ];

    const tincomeData = [
      ["Total Income\nPer Annum", formData.totalIncomePerAnnum],
    ];

    const siblingHeaders = ["Name", "Relationship", "University"];
    const siblingData = formData?.siblingDetails
      ? Object.values(formData.siblingDetails)
      : [];

    const image = new Image();
    const userImageForPdf = new Image();
    userImageForPdf.src = formData?.image;

    axios
      .post(
        "https://backend.form-seef.com/api/submit-form",

        formData
      )
      .then(function (response) {
        console.log(response);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your form has been submitted successfully. Please submit a printout of the downloaded form alongwith required documents and downloaded affidavit on stamp paper to the concern department of your university.",
          allowOutsideClick: () => false,
        }).then(() => {
          // window.location.href = "https://seef.sindh.gov.pk/";

          image.onload = function () {
            doc.rect(170, 50, 30, 35);
            doc.setFontSize(11);
            doc.text(
              "Photo\nPassport\nSize\n1.5in X 2in",
              185,
              55,
              null,
              null,
              "center"
            );
            doc.addImage(userImageForPdf, "png", 170, 50, 30, 35);
            doc.addImage(this, "png", 5, 5, 18, 22);
            doc.setFontSize(13.5).setFont(undefined, "bold");
            doc.text("GOVERNMENT OF SINDH", 123, 10);
            doc.text("COLLEGE EDUCATION DEPARTMENT", 108, 16);
            doc.text("SINDH EDUCATIONAL ENDOWMENT FUND", 102, 22);
            doc.setFontSize(11.5).setFont(undefined, "bold");
            doc.text("REGISTERED VIDE TRUST DEED NO. 625/2020", 107, 28);
            doc.setFontSize(17).setFont(undefined, "bold");
            doc.text(
              "Application for Award of Endowment Fund Scholarship",
              26,
              42
            );
            doc.setLineWidth(0.8);
            doc.line(10, 46, 200, 46);
            doc.setFontSize(14).setFont(undefined, "bold");
            doc.text("PLEASE READ ALL THE INSTRUCTIONS CAREFULLY", 10, 56);
            doc.setFontSize(10).setFont(undefined, "normal");
            doc.text(
              "1. Over-sea or Self-Financed Students are not eligible for Financial Assistance.",
              10,
              64
            );
            doc.text(
              "2. Please Submit the Hard Copy of this Form in your university's concern department.",
              10,
              69
            );
            doc.setLineWidth(0.5);
            doc.line(10, 76, 150, 76);
            doc.setFontSize(15).setFont(undefined, "bold");
            doc.text("1. ACADEMIC INFORMATION", 10, 85);
            doc.line(10, 88, 200, 88);

            doc.autoTable({
              body: tableData,
              startY: 92,
              columnStyles: {
                0: { fillColor: "#fff", fontSize: 11, columnWidth: 25 },
                1: { fillColor: "#fff", fontSize: 11, columnWidth: 5 },
                2: {
                  fillColor: "#fff",
                  fontSize: 12,
                  columnWidth: 45,
                  fontStyle: "bold",
                },
                3: { fillColor: "#fff", fontSize: 11, columnWidth: 25 },
                4: { fillColor: "#fff", fontSize: 11, columnWidth: 5 },
                5: {
                  fillColor: "#fff",
                  fontSize: 11.5,
                  columnWidth: 85,
                  fontStyle: "bold",
                },
              },
            });

            doc.setLineWidth(0.5);
            doc.line(10, 138, 200, 138);
            doc.setFontSize(15).setFont(undefined, "bold");
            doc.text("2. PERSONAL INFORMATION", 10, 147);
            doc.line(10, 150, 200, 150);

            doc.autoTable({
              body: tableData2,
              startY: 154,
              columnStyles: {
                0: { fillColor: "#fff", fontSize: 11, columnWidth: 25 },
                1: { fillColor: "#fff", fontSize: 11, columnWidth: 5 },
                2: {
                  fillColor: "#fff",
                  fontSize: 12,
                  columnWidth: 60,
                  fontStyle: "bold",
                },
                3: { fillColor: "#fff", fontSize: 11, columnWidth: 25 },
                4: { fillColor: "#fff", fontSize: 11, columnWidth: 5 },
                5: {
                  fillColor: "#fff",
                  fontSize: 12,
                  columnWidth: 60,
                  fontStyle: "bold",
                },
              },
            });
            // doc.line(10, 220, 200, 220);
            doc.setFontSize(13.5).setFont(undefined, "bold");
            doc.text("Details of Family Members", 10, 208);
            doc.line(10, 211, 75, 211);
            doc.autoTable({
              head: [headers],
              body: data,
              startY: 215,
              headStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
                halign: "center", // Center align header text
              },
              footStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
              },
              didParseCell: function (data) {
                data.cell.styles.fillColor = false; // remove background color
                data.cell.styles.lineWidth = 0.1; // set border width
                data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
                data.cell.styles.textColor = [0, 0, 0]; // set text color to black
              },
              didDrawPage: function (data) {
                // do something when a page is drawn
              },
            });
            doc.setLineWidth(0.5);
            doc.line(10, 284, 203, 283);
            doc.setFontSize(10).setFont(undefined, "bold");
            doc.text("Page 1 of 2", 100, 288);

            // Add a new page to the document
            doc.addPage();

            doc.setFontSize(10).setFont(undefined, "bold");
            doc.text("Page 2 of 2", 100, 10);

            doc.setLineWidth(0.5);
            doc.line(10, 13, 200, 13);
            doc.setFontSize(15).setFont(undefined, "bold");
            doc.text("3. FINANCIAL DETAILS", 10, 22);
            doc.line(10, 25, 200, 25);

            doc.setFontSize(13).setFont(undefined, "bold");
            doc.text("Residential Property / Immovable Assets Detail", 10, 31);
            doc.line(10, 33, 120, 33);

            doc.autoTable({
              head: [propertyHeaders],
              body: propertyData,
              startY: 36,
              headStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
                halign: "center", // Center align header text
              },
              footStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
              },
              didParseCell: function (data) {
                data.cell.styles.fillColor = false; // remove background color
                data.cell.styles.lineWidth = 0.1; // set border width
                data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
                data.cell.styles.textColor = [0, 0, 0]; // set text color to black
              },
            });
            doc.setFontSize(13).setFont(undefined, "bold");
            doc.text(
              "Source of Income (Provide DOCUMENTARY EVIDENCE for Income)",
              10,
              70
            );
            doc.line(10, 73, 175, 73);

            doc.autoTable({
              head: [incomeHeaders],
              body: incomeData,
              startY: 76,
              headStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
                halign: "center", // Center align header text
              },
              footStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
              },
              didParseCell: function (data) {
                data.cell.styles.fillColor = false; // remove background color
                data.cell.styles.lineWidth = 0.1; // set border width
                data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
                data.cell.styles.textColor = [0, 0, 0]; // set text color to black
              },
            });
            doc.autoTable({
              body: tincomeData,
              startY: 124,

              footStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
              },
              didParseCell: function (data) {
                data.cell.styles.fillColor = false; // remove background color
                data.cell.styles.lineWidth = 0.1; // set border width
                data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
                data.cell.styles.textColor = [0, 0, 0]; // set text color to black
              },
            });
            doc.setFontSize(13).setFont(undefined, "bold");
            doc.text(
              "Details Sibling Already Availing SEEF Scholarship",
              10,
              142
            );
            doc.line(10, 144, 120, 144);
            doc.autoTable({
              head: [siblingHeaders],
              body: [siblingData],
              startY: 146,
              headStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
                halign: "center", // Center align header text
              },
              footStyles: {
                textColor: [0, 0, 0], // set text color to black
                fillColor: false, // remove background color
              },
              didParseCell: function (data) {
                data.cell.styles.fillColor = false; // remove background color
                data.cell.styles.lineWidth = 0.1; // set border width
                data.cell.styles.lineColor = [0, 0, 0]; // set border color to black
                data.cell.styles.textColor = [0, 0, 0]; // set text color to black
              },
            });
            doc.line(10, 163, 200, 163);
            doc.setFontSize(14).setFont(undefined, "bold");
            doc.text("4. Required Documents", 10, 170);
            doc.line(10, 173, 200, 173);
            doc.autoTable({
              body: tableData3,
              startY: 176,
              columnStyles: {
                0: {
                  fillColor: "",
                  fontSize: 10.5,
                  columnWidth: 85,
                  cellPadding: { left: 1 },
                },
                1: {
                  fillColor: "",
                  fontSize: 10.5,
                  columnWidth: 100,
                  cellPadding: { left: 7 },
                },
              },
              didParseCell: function (data) {
                // Check if it's the first cell

                // Draw the checkbox
                const checkboxSize = 3;
                doc.setLineWidth(0.1);
                doc.rect(10, 176.5, checkboxSize, checkboxSize, "S");
                doc.rect(100, 176.5, checkboxSize, checkboxSize, "S");
                doc.rect(10, 184, checkboxSize, checkboxSize, "S");
                doc.rect(100, 184, checkboxSize, checkboxSize, "S");
                doc.rect(10, 193, checkboxSize, checkboxSize, "S");
                doc.rect(100, 193, checkboxSize, checkboxSize, "S");
                doc.rect(10, 201, checkboxSize, checkboxSize, "S");
                doc.rect(100, 201, checkboxSize, checkboxSize, "S");
                doc.rect(10, 210, checkboxSize, checkboxSize, "S");
                doc.rect(100, 210, checkboxSize, checkboxSize, "S");
                doc.rect(10, 232, checkboxSize, checkboxSize, "S");
                doc.rect(100, 232, checkboxSize, checkboxSize, "S");
                doc.rect(10, 244.5, checkboxSize, checkboxSize, "S");
                doc.rect(100, 244.5, checkboxSize, checkboxSize, "S");
              },
            });
            doc.line(10, 251, 200, 251);
            doc.setFontSize(14).setFont(undefined, "bold");
            doc.text("5. AFFIDAVIT", 10, 257);
            doc.line(10, 260, 200, 260);
            doc.setFontSize(13);
            doc.text(
              "Submit the Affidavit, duly printed on Stamp paper of value Rs. 50/, alongwith this form.",
              10,
              265
            );

            doc.setLineWidth(0.5);
            doc.line(195, 276, 145, 276);
            doc.setFontSize(10).setFont(undefined, "bold");
            doc.text("Signature of the Student", 150, 280);

            doc.setLineWidth(0.5);
            doc.line(82, 276, 15, 276);
            doc.setFontSize(10).setFont(undefined, "bold");
            doc.text("Signature of the Parents/Guardian", 20, 280);
            // Save the PDF
            doc.save("SEEF ScholarShip Form.pdf");

            // Show success message

            // const csrfToken = document
            //   .querySelector('meta[name="csrf-token"]')
            //   ?.getAttribute("content");
          };
          image.src = "/logo.png";

          // downloadPDF("../../public/Affidavit Sample.pdf");
          // downloadPDF("/Affidavit Sample.pdf");

          setLoading(false);
        });
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        Swal.fire("Error!", "Form submission failed!", "error");
      });
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const handleImageUpload = async (e) => {
    try {
      const file = e.target.files[0];
      const base64 = await convertBase64(file);
      setFormData({
        ...formData,
        image: base64,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDiscipline = (discipline) => {
    if (discipline === "Social Science") {
      Swal.fire({
        icon: "info",
        title: "Info",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowOutsideClick: () => false,
        html: `
        <p style="font-family: inherit;">
          The candidate must be enrolled in BS (Social Science) only, no other subject of social sciences will be entertained.
          <br>
          <b>Are you enrolled in BS (Social Science) program?</b>
        </p>
      `,
      }).then((result) => {
        if (result.value) {
          // User clicked on the confirmation button
          setFormData({
            ...formData,
            discipline_id: discipline,
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // User clicked on the cancel button
          Swal.fire({
            icon: "info",
            title: "Info",
            text: "You are not eligible for Sindh Educational Endowment Fund Scholorship.",
          }).then(() => {
            window.location.href = "https://seef.sindh.gov.pk/";
          });
        }
      });
    } else {
      setFormData({
        ...formData,
        discipline_id: discipline,
      });
    }
  };

  const handleCnicChange = (cnic) => {
    const pattern = /^\d{5}-\d{7}-\d$/;

    // setFormData((prevData) => ({
    //   ...prevData,
    //   cnic: cnic,
    // }));

    if (pattern.test(cnic)) {
      if (cnic.length == 15) {
        axios
          .post("https://backend.form-seef.com/api/check-cnic", { cnic: cnic })
          .then((res) => {
            if (res.data?.data == 0) {
              setFormData((prevData) => ({
                ...prevData,
                cnic: cnic,
              }));
            } else {
              Swal.fire({
                icon: "info",
                title: "Info",
                text: "You have already applied!",
                allowOutsideClick: () => false,
              }).then(() => {
                // window.location.href = "https://seef.sindh.gov.pk/";
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } else {
      console.log("Pattern does not match");
    }
  };

  const [searchTimer, setSearchTimer] = useState(null);

  const checkRollNumber = (roll_number) => {
    // setFormData((prevData) => ({
    //   ...prevData,
    //   roll_number: roll_number,
    // }));

    axios
      .post("https://backend.form-seef.com/api/check-roll_number", {
        roll_number: roll_number,
      })
      .then((res) => {
        if (res.data?.data == 0) {
          setFormData((prevData) => ({
            ...prevData,
            roll_number: roll_number,
          }));
        } else {
          Swal.fire({
            icon: "info",
            title: "Info",
            text: "You have already applied!",
            allowOutsideClick: () => false,
          }).then(() => {
            // window.location.href = "https://seef.sindh.gov.pk/";
          });
        }
      })
      .catch((error) => {
        console.log(error);
        // Handle the error here
      });
  };

  const handleRollChange = (roll_number) => {
    clearTimeout(searchTimer);

    setSearchTimer(
      setTimeout(() => {
        checkRollNumber(roll_number);
      }, 10000)
    );
  };

  const fetchUniversitiesData = () => {
    axios
      .get("https://backend.form-seef.com/api/universities")
      .then((res) => {
        if (res.data && res.data.data) {
          setUniversities(res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchAdmissionYearData = () => {
    axios
      .get("https://backend.form-seef.com/api/years")
      .then((res) => {
        if (res.data && res.data.data) {
          setYears(res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchDistrictData = () => {
    axios
      .get("https://backend.form-seef.com/api/domiciles")
      .then((res) => {
        if (res.data && res.data.data) {
          setDistrict(res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchDisciplineData = () => {
    axios
      .get("https://backend.form-seef.com/api/disciplines")
      .then((res) => {
        if (res.data && res.data.data) {
          setDiscipline(res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadPDF = (filePath) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.target = "_blank";
    link.download = filePath.split("/").pop(); // Extract the filename from the file path
    link.click();
  };

  useEffect(() => {
    fetchUniversitiesData();
  }, []);

  useEffect(() => {
    fetchAdmissionYearData();
  }, []);

  useEffect(() => {
    fetchDistrictData();
  }, []);

  useEffect(() => {
    fetchDisciplineData();
  }, []);

  const [loading, setLoading] = useState(false);
  return (
    <div className="p-4">
      {loading ? (
        <div
          style={{
            minHeight: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="/spinSvg.svg"
            width="auto"
            height="auto"
            alt="loader"
            srcset=""
          />
        </div>
      ) : previewMode ? (
        <>
          <div className="bg-white">
            <div className="shadow-2xl bg-gray-100 p-6 justify-between w-10/12 sm:w-8/12 md:w-8/12  text-center mx-auto">
              <Header />
              <div className="p-2 mt-6 text-2xl rounded-lg font-bold bg-red-500 -mb-6">
                Read the Form Carefully before clicking on SUBMIT button,
                because once the form is submitted it cannot be Edited or
                Corrected.
              </div>
              <Instruction
                userImage={formData?.image}
                previewMode={previewMode}
              />
              <div className="tex-left">
                <div className="text-left mx-3 sm:mx-6">
                  <h1 className=" font-bold text-2xl">
                    1. ACADEMIC INFORMATION
                  </h1>
                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                </div>
                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="fresh"
                      className=" text-left block font-bold mb-2"
                    >
                      Apply as
                      <span className="text-red-700 font-semibold">
                        *
                      </span> : {formData?.candidate}
                    </label>
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="roll"
                      className="block text-left font-bold mb-2"
                    >
                      University Reg. No #{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>{" "}
                      : {formData?.roll_number}
                    </label>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="admissionYear"
                      className="block text-left font-bold mb-2"
                    >
                      Year of Admission{" "}
                      <span className="text-red-700 font-semibold">*</span> :{" "}
                      {formData?.year_id}
                    </label>
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="university"
                      className="block text-left font-bold mb-2"
                    >
                      Name of University / Institute{" "}
                      <span className="text-red-700 font-semibold">*</span> :{" "}
                      {formData?.university_id}
                    </label>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="className=mb-4 md:w-1/2">
                    <label
                      htmlFor="grade-system"
                      className="block text-left font-bold mb-2"
                    >
                      Grade System
                      <span className="text-red-700 font-semibold">
                        *
                      </span> : {selectedGradeSystem || ""} :{" "}
                      {formData?.percentage_id}
                    </label>
                  </div>

                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="university"
                      className="block text-left font-bold mb-2"
                    >
                      Discipline{" "}
                      <span className="text-red-700 font-semibold">*</span> :{" "}
                      {formData?.discipline_id}
                    </label>
                  </div>
                </div>

                {/* Personal Data */}

                <div className=" mx-3 sm:mx-6">
                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                  <h1 className=" font-bold text-2xl text-left">
                    2. PERSONAL INFORMATION
                  </h1>

                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                </div>
                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="first"
                      className="block text-left font-bold mb-2"
                    >
                      First Name{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>{" "}
                      {formData?.first_name}
                    </label>
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="last"
                      className="block text-left font-bold mb-2"
                    >
                      Last Name{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>{" "}
                      {formData?.last_name}
                    </label>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="parent"
                      className="block text-left font-bold mb-2"
                    >
                      Father/Guardian Name{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>{" "}
                      {formData?.parentName}
                    </label>
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="cnic"
                      className="block text-left font-bold mb-2"
                    >
                      CNIC No. OF STUDENT{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>{" "}
                      {formData?.cnic}
                    </label>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="cell"
                      className="block text-left font-bold mb-2"
                    >
                      Phone Number{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                      {formData?.mobile}
                    </label>
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="home"
                      className="block text-left font-bold mb-2"
                    >
                      Phone Residence{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>{" "}
                      {formData?.landline}
                    </label>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="email"
                      className="block text-left font-bold mb-2"
                    >
                      Email{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>{" "}
                      {formData?.email}
                    </label>
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="domicile"
                      className="block text-left font-bold mb-2"
                    >
                      Domicile{" "}
                      <span className="text-red-700 font-semibold">*</span>{" "}
                      {formData?.domicile_id}
                    </label>
                  </div>
                </div>

                <div className="flex flex-col justify-center py-4">
                  <hr className="border-t-2 border-gray-700 my-2 rounded-none" />
                  <h1 className="text-left text-2xl font-bold">
                    Details of Family Members
                  </h1>
                  <hr className="border-t-2 border-gray-700 my-2 rounded-none" />
                  {students.length === 0 ? (
                    <p>No Family member added yet.</p>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse border">
                        <thead>
                          <tr>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Name
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Age
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Relationship
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Marital status
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Occupation
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Organisation
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {students.map((student) => (
                            <tr key={student.id} className="border">
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.name}
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.age} Years
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.relationship}
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.status}
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.occupation}
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.organisation}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* financial starts */}
                <div className="mx-3 sm:mx-6">
                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                  <h1 className="text-left font-bold text-2xl">
                    3. FINANCIAL INFORMATION
                  </h1>
                  
                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                  <div className="font-bold underline text-left mx-6 text-lg py-3">
                    RESIDENTIAL PROPERTY / IMMOVABLE ASSETS DETAILS
                  </div>
                </div>

                <div className="my-4 overflow-x-auto">
                  <table className="table-auto w-full sm:table">
                    <thead>
                      <tr>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/4">
                          Property Type
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/4">
                          Exact Location
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/4">
                          Area (in Acres/Sq Yards)
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/4">
                          Value (PKR)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border px-4 py-2">
                          {formData.property[0].propertyResidence}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.property[0].addressResidence}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.property[0].areaResidence}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.property[0].valueResidence}
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-4 py-2">
                          {nonResidenceProperty}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.property[1].addressNonResidence}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.property[1].areaNonResidence}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.property[1].valueNonResidence}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* financial ends */}

                {/* source of income starts */}
                <div className="font-bold underline text-left mx-6 text-lg py-3">
                  SOURCE OF INCOME PER ANNUM (Provide DOCUMENTARY EVIDENCE FOR
                  INCOME)
                </div>
                <div className="my-4 overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead>
                      <tr>
                        <th className="sm:table-cell px-4 py-2"></th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Father&apos;s
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Mother&apos;s
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Brother&apos;s
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Sister&apos;s
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Guardian&apos;s / Other&apos;s
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="sm:table-cell border px-4 py-2 font-bold">
                          Profession
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[0].fProfession}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[1].mProfession}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[2].bProfession}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[3].sProfession}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[4].gProfession}
                        </td>
                      </tr>
                      <tr>
                        <td className="sm:table-cell border px-4 py-2 font-bold">
                          Salary/Pension
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[0].fIncome}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[1].mIncome}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[2].bIncome}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[3].sIncome}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[4].gIncome}
                        </td>
                      </tr>
                      <tr>
                        <td className="sm:table-cell border px-4 py-2 font-bold">
                          Per Annum Income from all Sources
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[0].fTotalIncome}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[1].mTotalIncome}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[2].bTotalIncome}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[3].sTotalIncome}
                        </td>
                        <td className="border px-4 py-2">
                          {formData.income[4].gTotalIncome}
                        </td>
                      </tr>
                      Rs. {formData.totalIncomePerAnnum}/-
                    </tbody>
                  </table>
                  <table>
                    <tbody>
                      <tr className="justify-center">
                        <td className="sm:table-cell border w-2/12 px-4 py-2 text-xl font-bold">
                          Total Income Per Annum
                        </td>
                        <td className="border px-4 py-2 w-10/12 bg-white font-semibold text-2xl">
                          Rs. {allIncome}/-
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* source of income ends */}

                <div className="flex flex-col sm:flex-row gap-x-3 items-start mx-4">
                  <p className="text-xl font-bold mb-2 underline">
                    Wheter any of your sibling(s) is already availing the SEEF
                    Scholarship?
                  </p>
                  <div className="flex sm:flex-row">
                    <div className="flex items-center text-xl font-semibold sm:mx-5 mb-2">
                      <input
                        type="checkbox"
                        className="form-checkbox mr-2"
                        style={{ width: "1.25rem", height: "1.25rem" }}
                        id="yesCheckbox"
                        value="yes"
                        checked={isSiblingAvailingScholarship === true}
                      />
                      <label htmlFor="yesCheckbox">Yes</label>
                    </div>
                    <div className="flex items-center text-xl font-semibold sm:mx-5 mb-2">
                      <input
                        type="checkbox"
                        className="form-checkbox mr-2"
                        style={{ width: "1.25rem", height: "1.25rem" }}
                        id="noCheckbox"
                        value="no"
                        checked={isSiblingAvailingScholarship === false}
                      />
                      <label htmlFor="noCheckbox">No</label>
                    </div>
                  </div>
                </div>

                {formData?.siblingDetails ? (
                  <div className=" mx-4 items-start">
                    <p className=" mx-4 mt-4 mb-2 text-lg text-left font-semibold">
                      Details of Sibling Availing SEEF Scholarship:
                    </p>

                    <table className="border-collapse w-full border border-gray-300">
                      <thead className="">
                        <tr className="">
                          <th className="border border-gray-400 py-2 w-3/12 px-4">
                            Name
                          </th>
                          <th className="border border-gray-400 w-3/12 py-2 px-4">
                            Relationship
                          </th>
                          <th className="border border-gray-400 py-2 px-4">
                            University
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="border border-gray-400 bg-white py-2 w-3/12 px-4">
                            {formData?.siblingDetails?.name}
                          </td>
                          <td className="border border-gray-400 py-2 bg-white w-3/12 px-4">
                            {formData?.siblingDetails?.relationship}
                          </td>
                          <td className="border border-gray-400 py-2 bg-white px-4">
                            {formData?.siblingDetails?.university}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ) : null}
              </div>
              <Documents />

              {/* Sample Affidavit */}

              <div className="mx-3 sm:mx-6">
                <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                <h1 className="text-left font-bold text-2xl">
                  5. DOWNLOAD SAMPLE AFFIDAVIT
                </h1>
                <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                <div className=" flex text-red-600 gap-x-6 text-red-00 items-center font-bold text-left mx-6 text-lg py-3">
                  Before Submitting the Form Online, Download the Sample
                  Affidavit Form.
                  <a
                    href={AFFIDAVIT}
                    download="Sample-Affidavit-PDF"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className=" p-2 bg-blue-500 text-white rounded-md w-full md:w-auto hover:cursor-pointer hover:bg-white hover:text-blue-800 hover:font-bold">
                      SAMPLE AFFIDAVIT
                    </div>
                  </a>
                </div>
              </div>

              {/* Download and Edit Button */}

              <div className="mt-4">
                <button
                  className="bg-blue-500 hover:bg-red-500 text-white py-2 px-4 rounded mr-4"
                  onClick={handleDownload}
                >
                  SUBMIT AND DOWNLOAD
                </button>
                <button
                  className="bg-gray-500 hover:bg-green-500 text-white py-2 px-4 rounded"
                  onClick={handleEdit}
                >
                  EDIT
                </button>
              </div>
              {/* Download and Edit Button Edit */}
            </div>
          </div>
        </>
      ) : (
        // FORM FILLING
        <div className="bg-white">
          <div className="shadow-2xl bg-gray-100 p-6 justify-between w-10/12 sm:w-8/12 md:w-8/12  text-center mx-auto">
            <form onSubmit={handleSubmit}>
              <Header />
              <Instruction />

              {/* -------Academic--------- */}

              <div className="tex-left">
                <div className="text-left mx-3 sm:mx-6">
                  <h1 className=" font-bold text-2xl">
                    1. ACADEMIC INFORMATION
                  </h1>
                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                </div>
                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="fresh"
                      className=" text-left block font-bold mb-2"
                    >
                      Apply as{" "}
                      <span className="text-red-700 font-semibold">*</span>
                    </label>
                    <select
                      id="fresh"
                      name="fresh"
                      className="w-full py-2 px-4 border rounded-lg"
                      required
                      value={formData?.candidate}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          candidate: e.target.value,
                        })
                      }
                    >
                      <option value="">--Select--</option>
                      <option value="FRESH CANDIDATE">FRESH CANDIDATE</option>
                      {/* <option value="NO">NO</option> */}

                      {/* <!-- Add more options as needed --> */}
                    </select>
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="roll"
                      className="block text-left font-bold mb-2"
                    >
                      University Reg. No #{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      id="roll"
                      name="roll"
                      className="w-full py-2 px-4 border rounded-lg"
                      placeholder="Enter Your University Reg. No."
                      required
                      value={formData?.roll_number}
                      onChange={(e) => handleRollChange(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="admissionYear"
                      className="block text-left font-bold mb-2"
                    >
                      Year of Admission{" "}
                      <span className="text-red-700 font-semibold">*</span>
                    </label>
                    <select
                      id="admissionYear"
                      name="admissionYear"
                      className="w-full py-2 px-4 border rounded-lg"
                      required
                      value={formData?.year_id}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          year_id: e.target.value,
                        })
                      }
                    >
                      <option disabled selected>
                        --Select--
                      </option>
                      {years.map((year, index) => {
                        return (
                          <option key={index} value={year.name}>
                            {year.name}
                          </option>
                        );
                      })}

                      {/* <option value="">--Select--</option>
                       <option value="2023">2023</option>
                       <option value="2022">2022</option>
                       <option value="2021">2021</option> */}

                      {/* <!-- Add more options as needed --> */}
                    </select>
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="university"
                      className="block text-left font-bold mb-2"
                    >
                      Name of University / Institute{" "}
                      <span className="text-red-700 font-semibold">*</span>
                    </label>
                    <select
                      id="university"
                      name="university"
                      className="w-full py-2 px-4 border rounded-lg"
                      required
                      // value={university}
                      // onChange={(e) => setUniversity(e.target.value)}
                      value={formData?.university_id}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          university_id: e.target.value,
                        })
                      }
                    >
                      <option disabled selected>
                        --Select--
                      </option>
                      {universites.map((uni, index) => {
                        return (
                          <option key={index} value={uni.name}>
                            {uni.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="className=mb-4 md:w-1/2">
                    <label
                      htmlFor="grade-system"
                      className="block text-left font-bold mb-2"
                    >
                      Select Grade System
                      <span className="text-red-700 font-semibold">*</span>
                    </label>

                    <select
                      name="grade-system"
                      id="grade-system"
                      value={selectedGradeSystem || ""}
                      onChange={handleGradeSystemChange}
                      className="w-full p-2 border rounded-md mb-4"
                    >
                      <option value="">Select Grade System</option>
                      <option value={GradeSystem.CGPA}>CGPA</option>
                      <option value={GradeSystem.PERCENTAGE}>Percentage</option>
                      <option value={GradeSystem.FIRSTYEAR}>
                        First Year Student
                      </option>
                    </select>

                    {selectedGradeSystem && (
                      <div className="w-full text-left">
                        <label
                          htmlFor="grade-input"
                          className="mb-2 text-left font-bold"
                        >
                          Enter {selectedGradeSystem}
                          <span className="text-red-700 font-semibold">*</span>
                        </label>

                        {selectedGradeSystem === GradeSystem.FIRSTYEAR ? (
                          <div className="p-2 border rounded-md bg-gray-100">
                            First Year Student
                          </div>
                        ) : (
                          <input
                            type="text"
                            name="grade-input"
                            id="grade-input"
                            value={
                              selectedGradeSystem === GradeSystem.CGPA ||
                              selectedGradeSystem === GradeSystem.PERCENTAGE
                                ? formData?.percentage_id
                                : ""
                            }
                            required={
                              selectedGradeSystem === GradeSystem.CGPA ||
                              selectedGradeSystem === GradeSystem.PERCENTAGE
                            }
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                percentage_id: e.target.value,
                              });
                            }}
                            className="w-full mt-3 p-2 border rounded-md"
                          />
                        )}
                      </div>
                    )}
                  </div>

                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="university"
                      className="block text-left font-bold mb-2"
                    >
                      Discipline{" "}
                      <span className="text-red-700 font-semibold">*</span>
                    </label>
                    <select
                      id="discipline"
                      name="discipline"
                      className="w-full py-2 px-4 border rounded-lg"
                      required
                      // value={discipline}
                      // onChange={(e) => setDiscipline(e.target.value)}
                      value={formData?.discipline_id}
                      onChange={(e) => handleDiscipline(e.target.value)}
                    >
                      <option disabled selected>
                        --Select--
                      </option>
                      {discipline.map((disc, index) => {
                        return (
                          <option key={index} value={disc.name}>
                            {disc.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                {/* Personal Data */}

                <div className=" mx-3 sm:mx-6">
                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                  <h1 className=" font-bold text-2xl text-left">
                    2. PERSONAL INFORMATION
                  </h1>

                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                </div>
                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="first"
                      className="block text-left font-bold mb-2"
                    >
                      First Name{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                    </label>

                    <input
                      type="text"
                      id="first"
                      name="first"
                      className="w-full py-2 px-4 border rounded-lg"
                      placeholder="First Name"
                      required
                      // value={first}
                      // onChange={(e) => setFirst(e.target.value)}
                      value={formData?.first_name}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          first_name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="last"
                      className="block text-left font-bold mb-2"
                    >
                      Last Name{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      id="last"
                      name="last"
                      className="w-full py-2 px-4 border rounded-lg"
                      placeholder="Last Name"
                      // value={last}
                      required
                      value={formData?.last_name}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          last_name: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="parent"
                      className="block text-left font-bold mb-2"
                    >
                      Father/Guardian Name{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      id="parent"
                      name="parent"
                      className="w-full py-2 px-4 border rounded-lg"
                      placeholder="Enter father/guardian name"
                      required
                      value={formData?.parentName}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          parentName: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="cnic"
                      className="block text-left font-bold mb-2"
                    >
                      CNIC OF STUDENT{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      id="cnic"
                      name="cnic"
                      className="w-full py-2 px-4 border rounded-lg"
                      placeholder="42001-1234567-0"
                      required
                      value={formData?.cnic}
                      pattern="\d{5}-\d{7}-\d{1}"
                      onChange={(e) => handleCnicChange(e.target.value)}
                    />
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="cell"
                      className="block text-left font-bold mb-2"
                    >
                      Mobile Number{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                    </label>
                    <input
                      type="cell"
                      id="cell"
                      name="cell"
                      className="w-full py-2 px-4 border rounded-lg uppercase"
                      placeholder="03xx-xxxxxxx"
                      pattern="\d{4}-\d{7}"
                      required
                      // value={cell}
                      value={formData?.mobile}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          mobile: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="home"
                      className="block text-left font-bold mb-2"
                    >
                      Phone Residence{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      id="home"
                      name="home"
                      className="w-full py-2 px-4 border rounded-lg"
                      placeholder="Enter Landline OR Mobile number of father/Guardian"
                      required
                      // value={home}
                      value={formData?.landline}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          landline: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="flex flex-col md:flex-row md:justify-between md:gap-4">
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="email"
                      className="block text-left font-bold mb-2"
                    >
                      Email{" "}
                      <span className="text-red-700 font-semibold required:">
                        *
                      </span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="w-full py-2 px-4 border rounded-lg"
                      placeholder="Enter your email"
                      required
                      value={formData?.email}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-4 md:w-1/2">
                    <label
                      htmlFor="domicile"
                      className="block text-left font-bold mb-2"
                    >
                      Domicile & PRC(Form C){" "}
                      <span className="text-red-700 font-semibold">*</span>
                    </label>
                    <select
                      id="domicile"
                      name="domicile"
                      className="w-full py-2 px-4 border rounded-lg"
                      required
                      value={formData?.domicile_id}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          domicile_id: e.target.value,
                        })
                      }
                    >
                      <option disabled selected>
                        --Select--
                      </option>
                      {district.map((dist, index) => {
                        return (
                          <option key={index} value={dist.name}>
                            {dist.name}
                          </option>
                        );
                      })}

                      {/* <!-- Add more options as needed --> */}
                    </select>
                  </div>
                </div>

                <div className="border-2 border-gray-400 rounded-lg p-6 md:w-1/2 lg:w-full">
                  <label
                    htmlFor="photo"
                    className="block text-left  uppercase underline font-bold mb-2"
                  >
                    Upload Photograph
                  </label>
                  <div className="text-center">
                    <input
                      type="file"
                      id="photo"
                      name="photo"
                      className=" mb-2"
                      // value={photo}
                      required
                      onChange={handleImageUpload}
                    />
                  </div>

                  <p className="text-gray-600 text-center text-lg">
                    Please upload a Passport Size (1.5 inch X 2 inch) photograph
                    in JPG or PNG format. Maximum file size is 5MB.
                  </p>
                </div>

                <div className="flex flex-col justify-center py-4">
                  <h1 className="text-left text-2xl font-bold mb-4">
                    Add Details of Family Members
                  </h1>

                  <div className="flex gap-x-4 px-8 flex-col md:flex-row overflow-x-auto items-center mb-4">
                    <input
                      type="text"
                      placeholder="Name"
                      value={nameInputValue}
                      onChange={handleNameInputChange}
                      className="px-4 py-2 border border-gray-400 rounded-md mb-2 md:mb-0 md:mr-2 w-full md:w-44"
                      // required
                    />

                    <input
                      type="Number"
                      placeholder="Age"
                      value={ageInputValue}
                      onChange={handleAgeInputChange}
                      className="px-4 py-2 border border-gray-400 rounded-md mb-2 md:mb-0 md:mr-2 w-full md:w-20 appearance-none"
                      pattern="/^\d+$/"
                      // required
                    />
                    <select
                      value={relationshipInputValue}
                      onChange={handleRelationshipInputChange}
                      className="px-4 py-2 border border-gray-400 rounded-md mb-2 md:mb-0 md:mr-2 w-full md:w-36"
                      // required
                    >
                      <option value="">Relationship</option>
                      <option value="Brother">Brother</option>
                      <option value="Sister">Sister</option>
                      <option value="Mother">Mother</option>
                      <option value="Father">Father</option>
                      <option value="Guardian">Guardian</option>
                    </select>
                    <select
                      value={statusInputValue}
                      onChange={handleStatusInputChange}
                      className="px-4 py-2 border border-gray-400 rounded-md mb-2 md:mb-0 md:mr-2 w-full md:w-auto"
                      // required
                    >
                      <option value="">Marital Staus</option>
                      <option value="Married">Married</option>
                      <option value="UnMarried">UnMarried</option>
                      <option value="Divorced">Divorced</option>
                      <option value="Separated">Separated</option>
                      <option value="Widowed">Widowed</option>
                    </select>
                    <input
                      type="text"
                      placeholder="Occupation"
                      value={occupationInputValue}
                      onChange={handleOccupationInputChange}
                      className="px-4 py-2 border border-gray-400 rounded-md mb-2 md:mb-0 md:mr-2 w-full md:w-36"
                      // required
                    />
                    <input
                      type="text"
                      placeholder="Organisation"
                      value={organisationInputValue}
                      onChange={handleOrganisationInputChange}
                      className="px-4 py-2 border border-gray-400 rounded-md mb-2 md:mb-0 md:mr-2 w-full md:w-36"
                      // required
                    />
                    <div
                      onClick={handleAddStudent}
                      className="px-4 py-2 bg-blue-500 text-white rounded-md w-full md:w-auto hover:cursor-pointer hover:bg-white hover:text-blue-800 hover:font-bold"
                    >
                      Add
                    </div>
                  </div>

                  {students.length === 0 ? (
                    <p>No Family member added yet.</p>
                  ) : (
                    <div className="w-full overflow-x-auto">
                      <table className="w-full border-collapse border">
                        <thead>
                          <tr>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Name
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Age
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Relationship
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Marital status
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Occupation
                            </th>
                            <th className="border px-4 py-2 whitespace-nowrap">
                              Organisation
                            </th>
                            <th className="border px-4 py-2">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {students.map((student) => (
                            <tr key={student.id} className="border">
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.name}
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.age} Years
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.relationship}
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.status}
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.occupation}
                              </td>
                              <td className="border px-4 py-2 whitespace-nowrap">
                                {student.organisation}
                              </td>
                              <td className="border px-4 py-2">
                                <button
                                  onClick={() =>
                                    handleDeleteStudent(student.id)
                                  }
                                  className="text-red-500"
                                >
                                  &#10005;
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                {/* financial starts */}
                <div className="mx-3 sm:mx-6">
                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                  <h1 className="text-left font-bold text-2xl">
                    3. FINANCIAL INFORMATION
                  </h1>
                  <h1 className="text-left font-bold text-lg text-red-600 ">
                    Fill all the fields, DONOT Leave any field empty, if field is not required enter N/A. Else Form Cannot be submitted.
                  </h1>
                  <hr className="border-t-2 border-gray-700 my-5 rounded-none" />
                </div>
                <div className="font-bold text-left uppercase underline mx-6 text-lg py-2">
                  Details of Residential Property / Immovable Assets)
                </div>
                <div className="my-2 overflow-x-auto">
                  <table className="table-auto">
                    <thead>
                      <tr>
                        <th className="px-4 py-2 sm:w-3/12 lg:w-2/12">
                          Property Type
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/4">
                          Exact Location / Address
                        </th>
                        <th className="px-4 py-2 sm:w-3/12 lg:w-1/12">
                          Area (in Acres/Sq Yards)
                        </th>
                        <th className="px-4 py-2 sm:w-3/12 lg:w-1/12">
                          Value (PKR)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border px-4 py-2">
                          <select
                            value={formData.property[0].propertyResidence}
                            onChange={handlePropertyResidenceOnChange}
                            className="w-full border rounded-lg px-4 py-2"
                          >
                            <option value="Bungalow / Apartment">
                              --Select Residential--
                            </option>
                            <option value="Not Applicable">
                              Not Applicable
                            </option>
                            <option value="Bungalow">Bungalow</option>
                            <option value="Apartment">Apartment</option>
                          </select>
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter address"
                            value={formData.property[0].addressResidence}
                            onChange={handleAddressResidenceOnchange}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter area"
                            value={formData.property[0].areaResidence}
                            onChange={handleAreaResidenceOnchange}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter value"
                            value={formData.property[0].valueResidence}
                            onChange={handleValueResidenceOnchange}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border px-4 py-2">
                          <select
                            value={nonResidenceProperty}
                            onChange={handlePropertyNonResidenceOnChange}
                            className="w-full border rounded-lg px-4 py-2"
                          >
                            <option value="Land / Plot ">
                              --Select Immovable Assets--
                            </option>
                            <option value="Not Applicable">
                              Not Applicable
                            </option>
                            <option value="Plot (Commercial)">
                              Plot (Commercial)
                            </option>
                            <option value="Land (Commercial)">
                              Land (Commercial)
                            </option>
                            <option value="Land (Agricultural)">
                              Land (Agricultural)
                            </option>
                            <option value="Land (Both)">Land (Both)</option>
                          </select>
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter address"
                            value={formData.property[0].addressNonResidence}
                            onChange={handleNonResidenceAddress}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter area"
                            value={formData.property[0].areaNonResidence}
                            onChange={handleNonResidenceArea}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter value"
                            value={formData.property[0].valueNonResidence}
                            onChange={handleNonResidenceValue}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* financial ends */}

                {/* source of income starts */}
                <div className="font-bold underline mx-6 text-left  text-lg py-3">
                  SOURCE OF INCOME PER ANNUM (Provide DCOUMENTARY EVIDENCE FOR
                  INCOME)
                </div>
                <div className="my-4 overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead>
                      <tr>
                        <th className="sm:table-cell px-4 py-2"></th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Father&apos;s
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Mother&apos;s
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Brother&apos;s
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Sister&apos;s
                        </th>
                        <th className="px-4 py-2 sm:w-1/3 lg:w-1/6">
                          Guardian&apos;s / Other&apos;s
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="sm:table-cell border px-4 py-2 font-bold">
                          Profession
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter father's profession"
                            value={formData.income[0].fProfession}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  {
                                    ...prevState.income[0], // keep the first object as is
                                    fProfession: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the second object as is
                                  prevState.income[3], // keep the second object as is
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }))
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter mother's profession"
                            value={formData.income[0].mProfession}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  {
                                    ...prevState.income[1], // keep the second object as is
                                    mProfession: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[2], // keep the second object as is
                                  prevState.income[3], // keep the second object as is
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }))
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter brother's profession"
                            value={formData.income[0].bProfession}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  {
                                    ...prevState.income[2], // keep the third object as is
                                    bProfession: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[3], // keep the fourth object as is
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }))
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter sister's profession"
                            value={formData.income[0].sProfession}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the third object as is
                                  {
                                    ...prevState.income[3], // keep the fourth object as is
                                    sProfession: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }))
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter guardian's / other's profession"
                            value={formData.income[0].gProfession}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the third object as is
                                  prevState.income[3], // keep the fourth object as is
                                  {
                                    ...prevState.income[4], // keep the fifth object as is
                                    gProfession: e.target.value, // update the propertyResidence value
                                  },
                                ],
                              }))
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="sm:table-cell border px-4 py-2 font-bold">
                          Source of Income (Salary/Pension/Others)
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter father's salary/pension"
                            value={formData.income[0].fIncome}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  {
                                    ...prevState.income[0], // keep the first object as is
                                    fIncome: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the second object as is
                                  prevState.income[3], // keep the second object as is
                                  prevState.income[4], // keep the second object as is
                                ],
                              }))
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter mother's salary/pension"
                            value={formData.income[0].mIncome}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  {
                                    ...prevState.income[1], // keep the second object as is
                                    mIncome: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[2], // keep the second object as is
                                  prevState.income[3], // keep the second object as is
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }))
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter brother's salary/pension"
                            value={formData.income[0].bIncome}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  {
                                    ...prevState.income[2], // keep the third object as is
                                    bIncome: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[3], // keep the fourth object as is
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }))
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter sister's salary/pension"
                            value={formData.income[0].sIncome}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the third object as is
                                  {
                                    ...prevState.income[3], // keep the fourth object as is
                                    sIncome: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }))
                            }
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="text"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="Enter guardian's / other's salary/pension"
                            value={formData.income[0].gIncome}
                            // required
                            onChange={(e) =>
                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the third object as is
                                  prevState.income[3], // keep the fourth object as is
                                  {
                                    ...prevState.income[4], // keep the fifth object as is
                                    gIncome: e.target.value, // update the propertyResidence value
                                  },
                                ],
                              }))
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="sm:table-cell border px-4 py-2 font-bold">
                          Per Annum Income from all Sources
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="PER ANNUM INCOME"
                            value={formData.income[0].fTotalIncome}
                            // required
                            onChange={(e) => {
                              const currentValue =
                                e.target.value == "" ? 0 : e.target.value;
                              console.log("currentValue:", currentValue);
                              const previousValue =
                                formData.income[0].fTotalIncome == ""
                                  ? 0
                                  : formData.income[0].fTotalIncome;

                              const difference =
                                currentValue !== "" && previousValue !== ""
                                  ? currentValue - previousValue
                                  : 0;
                              setAllIncome(
                                (prevAllIncome) => prevAllIncome + difference
                              );

                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  {
                                    ...prevState.income[0], // keep the first object as is
                                    fTotalIncome: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the second object as is
                                  prevState.income[3], // keep the second object as is
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }));
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="PER ANNUM INCOME"
                            value={formData.income[0].mTotalIncome}
                            // required
                            onChange={(e) => {
                              const currentValue =
                                e.target.value == "" ? 0 : e.target.value;
                              const previousValue =
                                formData.income[1].mTotalIncome == ""
                                  ? 0
                                  : formData.income[1].mTotalIncome;

                              const difference =
                                currentValue !== "" && previousValue !== ""
                                  ? currentValue - previousValue
                                  : 0;
                              setAllIncome(
                                (prevAllIncome) => prevAllIncome + difference
                              );

                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  {
                                    ...prevState.income[1], // keep the second object as is
                                    mTotalIncome: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[2], // keep the second object as is
                                  prevState.income[3], // keep the second object as is
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }));
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="PER ANNUM INCOME"
                            value={formData.income[0].bTotalIncome}
                            // required
                            onChange={(e) => {
                              const currentValue =
                                e.target.value == "" ? 0 : e.target.value;
                              const previousValue =
                                formData.income[2].bTotalIncome == ""
                                  ? 0
                                  : formData.income[2].bTotalIncome;

                              const difference =
                                currentValue !== "" && previousValue !== ""
                                  ? currentValue - previousValue
                                  : 0;
                              setAllIncome(
                                (prevAllIncome) => prevAllIncome + difference
                              );

                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  {
                                    ...prevState.income[2], // keep the third object as is
                                    bTotalIncome: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[3], // keep the fourth object as is
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }));
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="PER ANNUM INCOME"
                            value={formData.income[0].sTotalIncome}
                            // required
                            onChange={(e) => {
                              const currentValue =
                                e.target.value == "" ? 0 : e.target.value;
                              const previousValue =
                                formData.income[3].sTotalIncome == ""
                                  ? 0
                                  : formData.income[3].sTotalIncome;

                              const difference =
                                currentValue !== "" && previousValue !== ""
                                  ? currentValue - previousValue
                                  : 0;
                              setAllIncome(
                                (prevAllIncome) => prevAllIncome + difference
                              );

                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the third object as is
                                  {
                                    ...prevState.income[3], // keep the fourth object as is
                                    sTotalIncome: e.target.value, // update the propertyResidence value
                                  },
                                  prevState.income[4], // keep the fifth object as is
                                ],
                              }));
                            }}
                          />
                        </td>
                        <td className="border px-4 py-2">
                          <input
                            type="number"
                            className="w-full border rounded-lg px-4 py-2"
                            placeholder="PER ANNUM INCOME"
                            value={formData.income[0].gTotalIncome}
                            // required
                            onChange={(e) => {
                              const currentValue =
                                e.target.value == "" ? 0 : e.target.value;
                              const previousValue =
                                formData.income[4].gTotalIncome == ""
                                  ? 0
                                  : formData.income[4].gTotalIncome;

                              const difference =
                                currentValue !== "" && previousValue !== ""
                                  ? currentValue - previousValue
                                  : 0;
                              setAllIncome(
                                (prevAllIncome) => prevAllIncome + difference
                              );

                              setFormData((prevState) => ({
                                ...prevState, // keep the previous state as is
                                income: [
                                  prevState.income[0], // keep the first object as is
                                  prevState.income[1], // keep the second object as is
                                  prevState.income[2], // keep the third object as is
                                  prevState.income[3], // keep the fourth object as is
                                  {
                                    ...prevState.income[4], // keep the fifth object as is
                                    gTotalIncome: e.target.value, // update the propertyResidence value
                                  },
                                ],
                              }));
                            }}
                            style={{ overflow: "hidden" }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table>
                    <tbody>
                      <tr className="justify-center">
                        <td className="sm:table-cell border w-2/12 px-4 py-2 text-xl font-bold">
                          Total Income Per Annum
                        </td>
                        <td className="border px-4 py-2 w-10/12 bg-white font-semibold text-2xl">
                          Rs. {allIncome}/-
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* source of income ends */}
              </div>

              <div className="flex flex-col sm:flex-row gap-x-4 items-start">
                <p className="text-xl font-bold mb-2  underline">
                  Whether any of your sibling(s) is already availing the SEEF
                  Scholarship?
                </p>
                <div className="flex items-center text-xl font-semibold mb-2">
                  <input
                    type="checkbox"
                    className="form-checkbox mr-2"
                    style={{ width: "1.25rem", height: "1.25rem" }}
                    id="yesCheckbox"
                    value="yes"
                    checked={isSiblingAvailingScholarship === true}
                    onChange={(e) => handleCheckboxChange(e, "yes")}
                  />
                  <label htmlFor="yesCheckbox">Yes</label>
                </div>
                <div className="flex items-center text-xl font-semibold mb-2">
                  <input
                    type="checkbox"
                    className="form-checkbox mr-2"
                    style={{ width: "1.25rem", height: "1.25rem" }}
                    id="noCheckbox"
                    value="no"
                    checked={isSiblingAvailingScholarship === false}
                    onChange={(e) => handleCheckboxChange(e, "no")}
                  />
                  <label htmlFor="noCheckbox">No</label>
                </div>
              </div>

              {formData?.siblingDetails && (
                <div className=" mx-4 items-start">
                  <p className=" mx-4 mt-4 mb-2 text-xl text-left font-semibold">
                    Details of Sibling Availing SEEF Scholarship:
                  </p>

                  <table className="border-collapse w-full border border-gray-300">
                    <thead className="">
                      <tr className="">
                        <th className="border border-gray-400 py-2 w-3/12 px-4">
                          Name
                        </th>
                        <th className="border border-gray-400 w-3/12 py-2 px-4">
                          Relationship
                        </th>
                        <th className="border border-gray-400 py-2 px-4">
                          University
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-400 bg-white py-2 w-3/12 px-4">
                          {formData?.siblingDetails?.name}
                        </td>
                        <td className="border border-gray-400 py-2 bg-white w-3/12 px-4">
                          {formData?.siblingDetails?.relationship}
                        </td>
                        <td className="border border-gray-400 py-2 bg-white px-4">
                          {formData?.siblingDetails?.university}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              <button
                type="submit"
                className="bg-blue-500 mt-4 text-white py-2 px-4 rounded w-40 hover:bg-white hover:text-blue-500 hover:font-bold"
              >
                CHECK PREVIEW
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
